import {Component, Input, OnInit} from '@angular/core';
import {LocationData} from '../../types/location/location-data';

@Component({
  selector: 'wsd-organization-address',
  templateUrl: './organization-address.component.html',
  styleUrls: ['./organization-address.component.css']
})
export class OrganizationAddressComponent {

  @Input()
  addresses: LocationData[];

  @Input()
  allowedTypes: string[];

  constructor() { }

}
